import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface LegalFooterProps {
  /** `split`: legal text left, links right. `centered`: legal text only. */
  layout?: 'split' | 'centered';
  className?: string;
}

const LEGAL = `© ${new Date().getFullYear()} Protega · EmbedMike India Private Limited`;

const LegalFooter: React.FC<LegalFooterProps> = ({ layout = 'split', className }) => (
  <footer
    className={cn(
      'tw-flex tw-w-full tw-items-center tw-gap-4 tw-text-[12px] tw-leading-4 tw-text-ds-text-tertiary',
      layout === 'split' ? 'tw-justify-between' : 'tw-justify-center tw-text-center',
      className,
    )}
  >
    <p>{LEGAL}</p>
    {layout === 'split' && (
      <p className="tw-shrink-0 tw-font-medium">
        <Link to="/terms" className="hover:tw-text-ds-text-primary">Terms</Link>
        {' · '}
        <Link to="/privacy-policy" className="hover:tw-text-ds-text-primary">Privacy</Link>
      </p>
    )}
  </footer>
);

export default LegalFooter;
